import {
    ProductMetafields,
    ProductSchema,
    ProductsRecentlyViewed,
    RelatedProducts,
    WishCloudScript,
    YotpoReviewsSection,
    YotpoScript,
} from '~/features/product-details/components';
import { ProductOverview } from '~/features/product-details/components/ProductOverview';
import { PDPProvider } from '~/features/product-details/context';
import { ProductDetailsPageProps } from '~/features/product-details/types';
import { Modules } from '~/lib';
import { Container } from '~/shared/components/Container';
import { DynamicBlockList } from '~/templates/blocks';

export const P50ProductDetailsPage: React.FC<ProductDetailsPageProps> = ({
    pageElements,
    bottomPageElements,
    data: pageData,
    breadcrumb,
}) => {
    const { product, productTopReviews, timestamp } = pageData;

    const hasYotpoReviews = !!product.c_yotpoReviewCount;

    return (
        <div>
            <WishCloudScript />

            {hasYotpoReviews && <YotpoScript />}

            <PDPProvider initialData={product} initialDataTimestamp={timestamp}>
                <ProductMetafields />
                <ProductSchema breadcrumb={breadcrumb} topReviews={productTopReviews} />

                {/* Modules above the product overview. */}
                <DynamicBlockList elements={pageElements as Modules[]} />

                <Container hasGutter>
                    <ProductOverview />
                </Container>

                {/* Modules below the product overview. */}
                <DynamicBlockList elements={bottomPageElements as Modules[]} />

                <RelatedProducts isCondensed />
                <ProductsRecentlyViewed isCondensed />

                {hasYotpoReviews && <YotpoReviewsSection />}
            </PDPProvider>
        </div>
    );
};
